import styled from "styled-components";

export const ButtonWrapper = styled.default.div`
    :before{
        content: "";
        background-image: linear-gradient(90deg, red, blue, green);
        bottom: -3.2rem;    
        width: calc(100% - 2rem);
        height: 1rem;
        will-change: filter;
        -webkit-filter: blur(.6rem);
        filter: blur(.6rem);
        -webkit-transform-origin: center center;
        -ms-transform-origin: center center;
        display:block;
        left:1rem;
        position: relative;
        transition: all .3s ease-in-out;
    }
    &:hover:before {
        bottom: -3.5rem;
        filter: blur(.5rem);
    }
    button{
        z-index: 2;
        position: relative
    }`;
